import Request from 'utilities/Request';

export const fetchPollById = cardId =>
  Request.get(`/api/content/v1/cards/poll/${cardId}`);

export const saveVote = (cardId, votes) =>
  Request.put(`/api/content/v1/cards/poll/${cardId}/vote`, {votes});
